import React, { useEffect, useState } from "react";
import { IoSearchOutline } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { getProductBatchReport } from "../../../redux/actions/Report.action";
import { Button } from "react-bootstrap";
import * as XLSX from "xlsx";

export default function ProductBatchReport() {
  const dispatch = useDispatch();
  const reportData = useSelector((state) => state.report);
  console.log("reportData",reportData);
  const [formData, setFormData] = useState({ search: "" });

  useEffect(() => {
    dispatch(getProductBatchReport(formData.search));
  }, [formData.search]);

  const data =
    reportData?.productBatchReport?.data?.filter((item) =>
      (item.productName || "")
        .toLowerCase()
        .includes(formData.search.toLowerCase())
    ) || [];

  const handleFormData = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleDownload = () => {
    const excelData = [];
    data.forEach((item) => {
      item.batches.forEach((batch) => {
        excelData.push({
          "Product Name": item.productName,
          "Batch No": batch.batchNo,
          "Purchase Qty": batch.purchaseQty,
          "Sold Qty": batch.soldQty,
          "Remaining Qty": batch.remainingQty,
        });
      });
    });

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Product Batch Report");
    XLSX.writeFile(workbook, "Product_Batch_Report.xlsx");
  };

  return (
    <>
      <div className="mt-[100px]">
        {/* Search + Download */}
        <div className="d-flex items-center gap-4">
          <div className="bg-white shadow-shadows py-[8px] px-[20px] rounded-full flex items-center gap-2 ms-auto">
            <IoSearchOutline />
            <input
              type="text"
              name="search"
              value={formData.search}
              onChange={handleFormData}
              className="w-full outline-none"
              placeholder="Search by Product Name..."
            />
          </div>
          <Button
            onClick={handleDownload}
            className="px-4 !bg-theme-dark border-0 text-white"
          >
            Download
          </Button>
        </div>

        <div className="text-end mt-4">
          Total Products:{" "}
          <span className="text-success border-b border-success">
            {data.length || 0}
          </span>
        </div>
      </div>

      {/* Table */}
      <div className="mt-[50px] mb-4">
        <div className="row bg-gray-100 font-bold uppercase text-sm text-[#4A5568] px-[24px] py-[12px]">
          {/* <div className="col-3">Product Name</div> */}
          <div className="col">Batch No</div>
          <div className="col">Purchase Qty</div>
          <div className="col">Sold Qty</div>
          <div className="col">Remaining Qty</div>
        </div>

        {data.length > 0 ? (
          data.map((product) => (
            <div key={product.productId} className="mb-3">
              <div className="row bg-[rgba(0,0,0,0.06)] font-semibold px-[24px] py-[8px]">
                <div className="col">{product.productName}</div>
              </div>
              {product.batches.map((batch, index) => (
                <div
                  key={index}
                  className="row bg-white mb-1 shadow-sm border-bottom"
                >
                  {/* <div className="col-3 px-[24px] py-[12px]">
                    {product.productName}
                  </div> */}
                  <div className="col px-[24px] py-[12px]">{batch.batchNo}</div>
                  <div className="col px-[24px] py-[12px]">
                    {batch.purchaseQty}
                  </div>
                  <div className="col px-[24px] py-[12px]">{batch.soldQty}</div>
                  <div
                    className={`col px-[24px] py-[12px] font-bold ${
                      batch.remainingQty < 0
                        ? "text-red-600"
                        : "text-green-600"
                    }`}
                  >
                    {batch.remainingQty}
                  </div>
                </div>
              ))}
            </div>
          ))
        ) : (
          <div className="px-[24px] py-[12px] bg-[rgba(0,0,0,0.06)] text-center">
            No data found
          </div>
        )}
      </div>
    </>
  );
}
